function assertDeclaredOptionWrite({ elementId, elementType, optionKey, typeIsRegistered, optionClass, ErrorClass = Error }) {
  if (!typeIsRegistered || optionClass) {
    return;
  }
  throw new ErrorClass(
    `DynamicElement.updateOption: element ${elementId} (${elementType}) does not declare the option "${optionKey}". `
    + "The write would be stored, but the read path returns undefined for any key the element type has no option "
    + "class for, so nothing could ever read it back. Declare the option on the element, or write a key it declares.",
    { elementId, elementType, optionKey },
  );
}

module.exports = { assertDeclaredOptionWrite };
